/* Digital X — shared interaction layer for Digital Quran / Digital Ummah / Digital Hadith
 * - icon-only share buttons (page share beside the language toggle, per-ayah / verse-of-the-day share)
 * - card hover: lift, accent colour per card, cursor spotlight; press feedback + ripple on touch
 * - scroll progress bar, deep links to an exact ayah (#ayah-36-12)
 * Pure enhancement: if anything here fails the pages keep working unchanged. */
(function () {
  "use strict";
  if (window.__dxfx) return; window.__dxfx = 1;
  var d = document, html = d.documentElement;
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var HOVER = window.matchMedia && matchMedia("(hover: hover) and (pointer: fine)").matches;

  function page() {
    if (d.getElementById("dxh")) return "hadith";
    if (d.querySelector(".dqh-lang") || d.getElementById("dxq-player")) return "quran";
    if (d.querySelector(".du[data-dxu]") || d.getElementById("duLangEn") || d.getElementById("sec-zakat")) return "ummah";
    return "";
  }
  var P = "";
  function ms() {
    try {
      if (P === "quran" && typeof lang === "string") return lang === "ms";
      if (P === "ummah" && typeof window.duLang === "number") return window.duLang === 1;
      if (P === "hadith") { var on = d.querySelector(".dxh-lang button.on"); if (on) return on.getAttribute("data-lang") === "1"; }
      var q = localStorage.getItem("quran-lang"); if (q) return q === "ms";
    } catch (e) {}
    return true;
  }
  function T(en, m) { return ms() ? m : en; }
  var IC_SHARE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5.5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="18.5" r="2.6"/><path d="m8.3 10.8 7.4-4.1M8.3 13.2l7.4 4.1"/></svg>';

  /* ---------------------------------------------------------------- toast */
  var toastEl, toastT;
  function toast(m) {
    if (!toastEl) { toastEl = d.createElement("div"); toastEl.className = "dxfx-toast"; toastEl.setAttribute("role", "status"); toastEl.setAttribute("aria-live", "polite"); d.body.appendChild(toastEl); }
    toastEl.textContent = m; toastEl.classList.add("on"); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 2000);
  }
  function copy(s) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(s);
    return new Promise(function (ok, no) {
      var ta = d.createElement("textarea"); ta.value = s; ta.setAttribute("readonly", ""); ta.style.cssText = "position:fixed;top:-1000px;opacity:0";
      d.body.appendChild(ta); ta.select(); var r = false; try { r = d.execCommand("copy"); } catch (e) {} ta.remove(); r ? ok() : no();
    });
  }
  function share(data, btn) {
    if (btn) { btn.classList.remove("dxfx-pulse"); void btn.offsetWidth; btn.classList.add("dxfx-pulse"); }
    var full = (data.text ? data.text + "\n\n" : "") + data.url;
    if (navigator.share) {
      return navigator.share({ title: data.title, text: data.text, url: data.url }).catch(function (e) {
        if (e && e.name === "AbortError") return;
        return copy(full).then(function () { toast(T("Link copied", "Pautan disalin")); });
      });
    }
    return copy(full).then(function () { toast(data.copied || T("Copied — ready to paste and share", "Disalin — sedia untuk ditampal & dikongsi")); },
      function () { toast(T("Could not copy the link", "Tidak dapat menyalin pautan")); });
  }
  function base() { return location.origin + location.pathname; }

  /* ---------------------------------------------------------------- icon-only share buttons */
  function shareBtn(cls, label) {
    var b = d.createElement("button");
    b.type = "button"; b.className = "dxfx-share " + (cls || "");
    b.innerHTML = IC_SHARE; b.setAttribute("aria-label", label); b.title = label;
    return b;
  }
  var PAGE_TXT = {
    quran: ["Digital Quran", "Read, listen to and understand the whole Quran, with translation, tafsir and 12 reciters.", "Baca, dengar dan fahami seluruh Al-Quran, dengan terjemahan, tafsir dan 12 qari."],
    hadith: ["Digital Hadith", "Read and search authentic hadith from the major collections, Arabic with translation.", "Baca dan cari hadis sahih daripada koleksi utama, teks Arab bersama terjemahan."],
    ummah: ["Digital Ummah", "Prayer times, Quran, hadith, duas, zakat and more in one place.", "Waktu solat, Al-Quran, hadis, doa, zakat dan banyak lagi dalam satu tempat."]
  };
  function pageShare() {
    var x = PAGE_TXT[P];
    return { title: x[0], text: x[0] + " — " + T(x[1], x[2]), url: base() };
  }
  function topShare() {
    if (d.querySelector(".dxfx-share--page")) return true;
    var lab = T("Share this page", "Kongsi halaman ini"), b;
    if (P === "ummah") {
      var u = d.getElementById("dxuShare"), hero = d.querySelector(".du-hero"), ul = hero && hero.querySelector(".du-lang");
      if (!u || !hero || !ul) return false;
      u.classList.add("dxfx-share", "dxfx-share--page", "dxfx-iconly"); u.setAttribute("aria-label", lab); u.title = lab;
      // language toggle + share live in their own row above the hero card, not inside it
      var oldRow = ul.parentNode !== hero ? ul.parentNode : null;
      var ur = d.createElement("div"); ur.className = "dxfx-toprow dxfx-toprow--u";
      var sp3 = d.createElement("span"); sp3.className = "dxfx-sp"; sp3.setAttribute("aria-hidden", "true");
      ur.appendChild(sp3); ur.appendChild(ul); ur.appendChild(u);
      hero.parentNode.insertBefore(ur, hero);
      if (oldRow && oldRow !== hero && !oldRow.children.length) oldRow.remove();
      return true;
    }
    if (P === "hadith") {
      var top = d.querySelector("#dxh .dxh-top"); if (!top) return false;
      // "Back to Digital Ummah" goes to the very top, above the language toggle (as on Digital Quran)
      var bl = d.querySelector("#dxh .dxh-backlink");
      if (bl) { bl.classList.add("dxfx-backtop"); top.parentNode.insertBefore(bl, top); }
      b = shareBtn("dxfx-share--page", lab); top.classList.add("dxfx-toprow");
      var sp = d.createElement("span"); sp.className = "dxfx-sp"; sp.setAttribute("aria-hidden", "true");
      top.insertBefore(sp, top.firstChild); top.appendChild(b);
    } else if (P === "quran") {
      var lg = d.querySelector(".dqh-lang"); if (!lg) return false;
      var row = d.createElement("div"); row.className = "dxfx-toprow dxfx-toprow--q";
      lg.parentNode.insertBefore(row, lg);
      var sp2 = d.createElement("span"); sp2.className = "dxfx-sp"; sp2.setAttribute("aria-hidden", "true");
      row.appendChild(sp2); row.appendChild(lg);
      b = shareBtn("dxfx-share--page", lab); row.appendChild(b);
    } else return false;
    b.addEventListener("click", function () { share(pageShare(), b); });
    return true;
  }
  function relabel() {
    d.querySelectorAll(".dxfx-share--page").forEach(function (b) { var l = T("Share this page", "Kongsi halaman ini"); b.setAttribute("aria-label", l); b.title = l; });
    d.querySelectorAll(".dxfx-share--ayah").forEach(function (b) { var l = T("Share ayah ", "Kongsi ayat ") + (b.dataset.key || ""); b.setAttribute("aria-label", l); b.title = l; });
    d.querySelectorAll(".dxfx-share--daily, .dxu-vshare").forEach(function (b) { var l = T("Share this verse", "Kongsi ayat ini"); b.setAttribute("aria-label", l); b.title = l; });
  }

  /* Quran: share each ayah in the reader + the verse of the day; deep link #ayah-S-V */
  function surahName(n) { try { var s = SURAHS[n - 1]; return s ? s.t : ""; } catch (e) { return ""; } }
  function ayahData(key, ar, tr) {
    var p = key.split(":"), nm = surahName(+p[0]);
    var ref = "QS " + (nm ? nm + " " : "") + key;
    return { title: ref, text: (ar ? ar.trim() + "\n\n" : "") + (tr ? "“" + tr.trim().replace(/^\d+\.\s*/, "") + "”\n" : "") + "— " + ref, url: base() + "#ayah-" + p[0] + "-" + p[1] };
  }
  function addAyahShares(root) {
    (root || d).querySelectorAll(".rv[data-key]").forEach(function (rv) {
      if (rv.querySelector(".dxfx-share--ayah")) return;
      var bm = rv.querySelector(".q-chip.bmk"); if (!bm) return;
      var key = rv.dataset.key, b = shareBtn("q-chip dxfx-share--ayah", T("Share ayah ", "Kongsi ayat ") + key);
      b.dataset.key = key;
      bm.parentNode.insertBefore(b, bm.nextSibling);
      b.addEventListener("click", function () {
        var arEl = rv.querySelector(".rv-ar"), ar = "";
        if (arEl) { var c = arEl.cloneNode(true); c.querySelectorAll(".rv-n").forEach(function (n) { n.remove(); }); ar = c.textContent; }
        var tr = rv.querySelector(".rv-tr");
        share(ayahData(key, ar, tr && tr.textContent), b);
      });
    });
  }
  function dailyShare() {
    var shuf = d.getElementById("dxq-dailyShuf");
    if (!shuf || shuf.parentNode.querySelector(".dxfx-share--daily")) return;
    var b = shareBtn("dxfx-share--daily", T("Share this verse", "Kongsi ayat ini"));
    shuf.parentNode.insertBefore(b, shuf.nextSibling);
    b.addEventListener("click", function () {
      var key = ""; try { key = dailyKey; } catch (e) {}
      if (!key) return;
      var ar = d.getElementById("dxq-dailyAr"), tr = d.getElementById("dxq-dailyTr");
      share(ayahData(key, ar && ar.textContent, tr && tr.textContent), b);
    });
  }
  function deepLink() {
    var m = /^#ayah-(\d{1,3})-(\d{1,3})$/.exec(location.hash || "");
    if (!m) return;
    var n = 0;
    (function go() {
      if (typeof window.gotoAyah === "function" && typeof SURAHS !== "undefined") {
        try { window.gotoAyah(m[1] + ":" + m[2]); } catch (e) {}
        return;
      }
      if (++n < 80) setTimeout(go, 150);
    })();
  }
  function quranExtras() {
    dailyShare();
    var body = d.getElementById("dxq-readBody");
    if (body && !body._dxfx) {
      body._dxfx = 1; addAyahShares(body);
      new MutationObserver(function () { addAyahShares(body); }).observe(body, { childList: true });
    }
    return !!body;
  }
  function ummahExtras() {
    var v = d.querySelector(".dxu-vshare");
    if (v && !v.classList.contains("dxfx-iconly")) { v.classList.add("dxfx-share", "dxfx-share--daily", "dxfx-iconly"); relabel(); }
  }

  /* ---------------------------------------------------------------- cards: accent colour, lift, spotlight, ripple */
  var ACC = ["61,123,255", "45,212,191", "157,123,255", "245,183,72", "255,122,133", "95,224,160"];
  var LIFT = {
    quran: ".dq-tile, #dxq-list .card, .dqp-hjump",
    ummah: ".dxu-tile, .du-ev, .du-w, .dxz .ztiers button, .dxu-cont",
    hadith: ".dxh-col, .dxh-cont"
  };
  var GLOW = {
    quran: ".daily, #dxq-dailyCard, .dqh-search, .rv[data-key]",
    ummah: ".du-card.du-sec, .du-feature, .dxz .zg, .dxz .zres",
    hadith: ".dxh-card, .dxh-panel, .dxh-about, .dxh-heroform"
  };
  function tagCards() {
    var sel = (LIFT[P] || "") + "," + (GLOW[P] || "");
    d.querySelectorAll(sel).forEach(function (c) {
      if (c._dxfx) return; c._dxfx = 1;
      var lift = c.matches(LIFT[P]);
      c.classList.add("dxfx-card", lift ? "dxfx-lift" : "dxfx-glowonly");
      // accent colour: cycles through the palette by position among siblings of the same kind
      var i = 0, s = c; while ((s = s.previousElementSibling)) if (s.classList && s.classList.contains("dxfx-card")) i++;
      c.style.setProperty("--fx-a", ACC[i % ACC.length]);
      if (getComputedStyle(c).position === "static") c.classList.add("dxfx-rel");
    });
  }
  var glow, glowHost = null;
  function ensureGlow() { if (!glow) { glow = d.createElement("span"); glow.className = "dxfx-glow"; glow.setAttribute("aria-hidden", "true"); } return glow; }
  function onMove(e) {
    var c = e.target.closest && e.target.closest(".dxfx-card");
    if (c !== glowHost) {
      if (glowHost) glowHost.classList.remove("dxfx-hot");
      glowHost = c;
      if (c) { var g = ensureGlow(); if (g.parentNode !== c) c.appendChild(g); c.classList.add("dxfx-hot"); }
    }
    if (c) { var r = c.getBoundingClientRect(); c.style.setProperty("--mx", (e.clientX - r.left) + "px"); c.style.setProperty("--my", (e.clientY - r.top) + "px"); }
  }
  function ripple(e) {
    if (RM || e.pointerType === "mouse") return;
    var c = e.target.closest && e.target.closest(".dxfx-lift, .dxfx-share, .dxz .zseg button, .dxh-btn, .du-btn, .dq-chip, .chip");
    if (!c) return;
    var r = c.getBoundingClientRect(), s = d.createElement("span"), sz = Math.max(r.width, r.height) * 1.2;
    s.className = "dxfx-rip"; s.setAttribute("aria-hidden", "true");
    s.style.cssText = "width:" + sz + "px;height:" + sz + "px;left:" + (e.clientX - r.left - sz / 2) + "px;top:" + (e.clientY - r.top - sz / 2) + "px";
    if (getComputedStyle(c).position === "static") c.classList.add("dxfx-rel");
    c.classList.add("dxfx-ripwrap"); c.appendChild(s);
    setTimeout(function () { s.remove(); }, 650);
  }

  /* ---------------------------------------------------------------- scroll progress */
  function progress() {
    var bar = d.createElement("div"); bar.className = "dxfx-prog"; bar.setAttribute("aria-hidden", "true");
    d.body.appendChild(bar);
    var tick = false;
    function upd() {
      tick = false;
      var h = d.documentElement.scrollHeight - innerHeight;
      bar.style.transform = "scaleX(" + (h > 0 ? Math.min(1, Math.max(0, scrollY / h)) : 0) + ")";
    }
    addEventListener("scroll", function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    addEventListener("resize", upd); upd();
  }


  /* ---------------------------------------------------------------- hero titles: second word in the accent blue, like Digital Hadith */
  function accentTitles() {
    d.querySelectorAll(".dqh-title, .dxu-title").forEach(function (h) {
      if (h.querySelector(".dxfx-acc")) return;
      var g = h.querySelector(".g");
      if (g) { g.classList.add("dxfx-acc"); return; }
      var w = d.createTreeWalker(h, NodeFilter.SHOW_TEXT), tn, last = null;
      while ((tn = w.nextNode())) if (/\S/.test(tn.nodeValue)) last = tn;
      if (!last) return;
      var m = /^(.*?)(\S+)(\s*)$/.exec(last.nodeValue);
      if (!m || !/^(Quran|Ummah)$/i.test(m[2])) return;
      var sp = d.createElement("span"); sp.className = "dxfx-acc"; sp.textContent = m[2];
      var frag = d.createDocumentFragment();
      if (m[1]) frag.appendChild(d.createTextNode(m[1]));
      frag.appendChild(sp);
      if (m[3]) frag.appendChild(d.createTextNode(m[3]));
      last.parentNode.replaceChild(frag, last);
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    P = page(); if (!P) return false;
    html.classList.add("dxfx", "dxfx-" + P);
    if (!topShare()) return false;
    if (P === "quran") deepLink();
    try { progress(); } catch (e) {}
    tagCards(); accentTitles();
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; tagCards(); accentTitles(); if (P === "quran") quranExtras(); if (P === "ummah") ummahExtras(); });
    }).observe(d.body, { childList: true, subtree: true });
    if (P === "quran") quranExtras();
    if (P === "ummah") ummahExtras();
    if (HOVER && !RM) {
      d.addEventListener("pointermove", onMove, { passive: true });
      d.addEventListener("pointerleave", function () { if (glowHost) glowHost.classList.remove("dxfx-hot"); glowHost = null; });
    }
    d.addEventListener("pointerdown", ripple, { passive: true });
    d.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("#dxq-langEn, #dxq-langMs, [data-dqh-lang], .dqh-lang button, #duLangEn, #duLangBm, .dxu-lang button, .du-lang button, .dxh-lang button")) setTimeout(relabel, 120);
    }, true);
    addEventListener("hashchange", function () { if (P === "quran") deepLink(); });
    relabel();
    return true;
  }
  var n = 0;
  (function wait() { if (boot()) return; if (++n < 150) setTimeout(wait, 100); })();
})();
